<router-outlet></router-outlet>
<ngx-sonner-toaster position="bottom-center" />
<!-- Asesor IA: botón flotante liviano; el chat se descarga al usarlo (solo si está disponible para el usuario) -->
<asesor-montaje />
